
import Logging from '@/logging';
import Vue from 'vue';

export default Vue.extend({
	props: {
		item: { type: Object, required: true }
	},
	methods: {
		handleInvoiceClick(val) {
			Logging.log('handleInvoiceClick', val);
			this.$router.push({ name: 'invoice-detail', params: { reference: val, participant: this.$store.getters.selectedParticipantStore } });
		}
	}
});
